// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e18c938f","389":"c81febd8","455":"2d8974f2","977":"fe636447"}[chunkId] + ".chunk.js";
};